import styles from './styles.module.css';
import { useState } from 'react';
import Modal from 'react-responsive-modal';
import { Notify } from '../../../Notify';
import { api } from '../../../../server/api';
import { Button } from '../../../Button';
import { ModalInfoContactUs } from '../ModalInfoContactUs';

interface IModalContactUs {
  modalIsOpen: boolean;
  closeModal: () => void;
  client: {
    isActiveIara: string;
    isActiveWhatsapp: string;
  };
  player: Record<string, unknown>;
}

export function ModalContactUs({
  modalIsOpen,
  closeModal,
  client,
  player,
}: IModalContactUs) {
  const [mensageContactUs, setMensageContactUs] = useState<string>();
  const [modalInfoContactUsIsOpen, setModalInfoContactUsIsOpen] =
    useState<boolean>(false);

  const handleFormSubmit = async () => {
    const parameters = {
      userType: 'player',
      searchFunctionality: 'contactUs',
      player: player,
      client: client,
      message: mensageContactUs,
    };

    const { data } = await api.post('/search', parameters);

    if (data.success) {
      setModalInfoContactUsIsOpen(!modalInfoContactUsIsOpen);

      closeModal();
    } else {
      Notify('Não foi possivel enviar email', 'info_sad');
    }
  };

  return (
    <>
      <Modal open={modalIsOpen} onClose={closeModal} center>
        <>
          <div className="contents-modal">
            <h2 className="title-modal">
              Dúvidas ou sugestões? Será um prazer ouvir o que você tem a dizer!
            </h2>
            <p className="subtitle-modal">
              Envie para nós como está sendo sua experiência com a plataforma.
            </p>
            <div className="d-flex justify-content-center">
              <textarea
                name="message"
                className={styles.textarea}
                placeholder="Escreva sua mensagem"
                onChange={(e) => setMensageContactUs(e.target.value)}
              />
            </div>
          </div>
          <div className={styles.contentBtn}>
            <Button
              isModal
              text="Enviar mensagem"
              type="button"
              color="primary"
              onClick={handleFormSubmit}
            />
          </div>
        </>
      </Modal>
      <ModalInfoContactUs
        closeModal={() =>
          setModalInfoContactUsIsOpen(!modalInfoContactUsIsOpen)
        }
        modalIsOpen={modalInfoContactUsIsOpen}
      />
    </>
  );
}
